
import {TEAM_MEMBER_INTERVIEW_REQUEST, TEAM_MEMBER_INTERVIEW_SUCCESS,TEAM_MEMBER_INTERVIEW_FAIL} from "../constants/AuthConstant"


const axios = require("axios");

export const TeamMemberInterviewAction = (VENDORID,pageNumber) => {
    return function (dispatch) {
      dispatch({
        type: TEAM_MEMBER_INTERVIEW_REQUEST,
        payload: true,
      });
     
      let OPTION = {
       url: `${process.env.REACT_APP_API_PATH}/ebench/interview/get_interview_of_team_member?vendorId=${VENDORID}&pageNumber=${pageNumber}&pageSize=10&flag=true`,
        method: "GET",
        headers: {
          "content-type": "application/json",
   
        },
      };
      axios(OPTION)
        .then((res) => {
            console.log(res.data,"hello");
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: TEAM_MEMBER_INTERVIEW_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: TEAM_MEMBER_INTERVIEW_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };